import { useTranslation } from "@opendash/i18n";
import { Input } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

export default observer(
  (props: { value: string; setValue: (value: string) => void }) => {
    const t = useTranslation();

    return (
      <>
        {!props.setValue && <span>{t(props.value)}</span>}
        {props.setValue && (
          <Input
            value={props.value}
            onChange={(e) => props.setValue(e.target.value)}
          />
        )}
      </>
    );
  }
);
